import type { UseFormReturn } from 'react-hook-form';
import { Labeled, Radio, RadioGroup, Stack } from '@sixui/ui';
import stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IStartupScreenSettingsFormValues } from './StartupScreenSettingsForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { FormFileUploader } from '~/components/organisms/fields/FileUploader';

export type IStartupScreenSettingsFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IStartupScreenSettingsFormValues>;
  appId: string;
};

const styles = stylex.create({
  radioSection: {
    marginLeft: 16,
    marginTop: 8,
  },
});

export const StartupScreenSettingsFormMainSection: React.FC<
  IStartupScreenSettingsFormMainSectionProps
> = (props) => {
  const { sx, form, appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <FormSection sx={sx}>
        <Labeled
          label={t('StartupScreenSettingsFormMainSection.fields.video.label')}
          required
        >
          <FormFileUploader
            control={form.control}
            name="videos"
            appId={appId}
            maxFiles={1}
            acceptTypes={['video']}
            rules={{ required: true }}
          />
        </Labeled>

        <Labeled
          label={t('StartupScreenSettingsFormMainSection.fields.mode.label')}
          supportingText={t(
            'StartupScreenSettingsFormMainSection.fields.mode.supportingText',
          )}
          required
        >
          <FormField as={RadioGroup} control={form.control} name="mode">
            <Stack gap={3} sx={styles.radioSection}>
              <Labeled
                label={t(
                  'StartupScreenSettingsFormMainSection.fields.mode.options.always.label',
                )}
                labelPosition="right"
              >
                {(elementProps) => <Radio value="always" {...elementProps} />}
              </Labeled>
              <Labeled
                label={t(
                  'StartupScreenSettingsFormMainSection.fields.mode.options.once.label',
                )}
                labelPosition="right"
              >
                {(elementProps) => <Radio value="once" {...elementProps} />}
              </Labeled>
            </Stack>
          </FormField>
        </Labeled>
      </FormSection>
    </>
  );
};
